import { render, staticRenderFns } from "./approval-leave-info.vue?vue&type=template&id=a4a79888&scoped=true"
import script from "./approval-leave-info.vue?vue&type=script&lang=js"
export * from "./approval-leave-info.vue?vue&type=script&lang=js"
import style0 from "./approval-leave-info.vue?vue&type=style&index=0&id=a4a79888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a79888",
  null
  
)

export default component.exports